/**
 * Module dependencies.
 */

import { NextPage } from 'next/types';
import Legal from 'src/components/legal';
import useTranslate from 'src/hooks/use-translate';

/**
 * `PrivacyPolicy` page.
 */

const PrivacyPolicy: NextPage = () => {
  const { translate } = useTranslate();

  return (
    <Legal
      subtitle={translate('privacy-policy:subtitle')}
      text={translate('privacy-policy:text')}
      title={translate('privacy-policy:title')}
    />
  );
};

/**
 * Export `PrivacyPolicy` page.
 */

export default PrivacyPolicy;
